import {MODES} from '../../IssueProfile/Modes';

export const executeIssueProfileDisplayAction = (parent, id) => {
    parent.props.history.push({
        pathname: '/issueProfile/displayIssueProfile',
        state: {id: id, mode: MODES.DISPLAY},
    });
};
